import config from "../config.js";
import RequestManager from "./request.js";
import { codeAppliDemandee } from "./appli.js";

export default class Connexion {

    static connecter(id, mdp) {
        var url = config.urlBackEndParent+"api/Client/connexion";
        const data = {
            id: id,
            mdp: mdp,
            // Application demandee, deduite du domaine d'entree. Absente sur
            // login.fisi.fr : le backend applique alors son defaut historique et rien
            // ne change pour les parcours existants.
            appli: codeAppliDemandee()
        }
        //console.log(data);
        return RequestManager.post(url, data)
            .then(response => {
                //console.log("Réponse brute:", response);
                //console.log("Réponse formatée:", JSON.stringify(response, null, 2)); // Affichage propre
                //alert('Retour Connection0 ' + response);
                return response;
            })
            .catch(error => console.error(error));
    }
    

    // Ticket d'acces a une autre application du portail pour l'utilisateur connecte (menu
    // « Choix de l'application ») : { success, BackEndLink, Ticket, resMsg }.
    static ticketAppli(appli) {
        const url = `${config.urlBackEndParent}api/Client/ticketAppli?appli=${encodeURIComponent(appli)}`
        return RequestManager.get(url)
            .then(response => response)
            .catch(error => console.error(" error on Connexion.ticketAppli() : ", error));
    }

    static connecterWithToken() {
        // Endpoint [HttpGet] cote backend : le token part dans l'en-tete Authorization
        // (gere par RequestManager). Un POST ici renvoie 405 Method Not Allowed.
        let urlConnecterWithToken = `${config.urlBackEndParent}api/Client/connexionWithToken`
        return RequestManager.get(urlConnecterWithToken)
            .then(response => {
                return response;
            })
            .catch(error => console.error(" error on Connexion.connecterWithToken() : ", error))
    }

    static async connecterWithTokenAsync() {
        let urlConnecterWithToken = `${config.urlBackEndParent}api/Client/connexionWithToken`;

        try {
            // GET (et non POST) : l'endpoint est [HttpGet], le token est dans l'en-tete.
            const response = await RequestManager.get(urlConnecterWithToken);
            return response;
        } catch (error) {
            console.error("Erreur dans Connexion.connecterWithTokenAsync :", error);
            return null;
        }
    }

    static connecterWithRPPS(RPPS) {
        let urlConnecterWihRPPS = `${config.urlBackEndParent}api/Client/connecterWithRPPS`;
        let data = {
            RPPS: RPPS
        }
        return RequestManager.post(urlConnecterWihRPPS, data)
            .then(response => {
                return response;
            })
            .catch(error => console.error(" error on Connexion.connecterWithCPS() : ", error))
    }
    static async connecterWithRPPSAsync(RPPS) {
        let urlConnecterWihRPPS = `${config.urlBackEndParent}api/Client/connecterWithRPPS`;
        let data = {
            RPPS: RPPS
        }
        return await RequestManager.post(urlConnecterWihRPPS, data)
            .then(response => {
                return response;
            })
            .catch(error => console.error(" error on Connexion.connecterWithCPSAsync() : ", error))
    }

    // Auth CPS forte (challenge-reponse signe). 1) recuperer un nonce serveur.
    // En cas d'echec reseau, renvoie { _erreur: "<message lisible>" } (backend injoignable...).
    static getChallengeCPS() {
        let url = `${config.urlBackEndParent}api/Auth/challenge`;
        return RequestManager.getStrict(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.error("[CPS] getChallengeCPS :", error);
                return { _erreur: RequestManager.decrireErreur(error) };
            })
    }

    // 2) poster l'assertion SAML signee par la carte ; le backend verifie tout (signature
    // carte, chaine IGC-Sante, RPPS du certificat) et renvoie { success, Token, BackEndLink, resMsg }.
    // En cas d'echec reseau, renvoie { success:false, _erreur:"<message lisible>" }.
    static connecterWithCPS(nonce, assertionSignee) {
        let url = `${config.urlBackEndParent}api/Auth/connecterWithCPS`;
        let data = {
            nonce: nonce,
            assertionSignee: assertionSignee,
            appli: codeAppliDemandee()
        }
        return RequestManager.post(url, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.error("[CPS] connecterWithCPS :", error);
                return { success: false, _erreur: RequestManager.decrireErreur(error) };
            })
    }

    static async getInfosPSIdent(RPPS) {
        let url = `${config.urlBackEndParent}api/Client/getInfosPSIdent?RPPS=${RPPS}`;
        return await RequestManager.get(url)
            .then(response => {
                return response;
            })
            .catch(error => console.error("error on Connexion.getInfosPSIdent\n", error));
    }

}
